const GCS_PUBLIC_URL = "https://storage.googleapis.com/imagem_produtos";

/**
 * Converte URL de imagem do backend proxy para URL direta do GCS
 *
 * Antes: http://backend/api/utils/get_image?user_id=abc&image_id=123
 * Depois: https://storage.googleapis.com/imagem_produtos/abc/123.png
 */
export function getDirectImageUrl(imagePath: string | undefined): string {
  if (!imagePath) return '/no_icon.png';

  // Se já é uma URL do GCS, retorna como está
  if (imagePath.includes('storage.googleapis.com')) {
    return imagePath;
  }

  // Se é uma URL do backend proxy, converte para GCS direto
  if (imagePath.includes('/api/utils/get_image')) {
    try {
      const url = new URL(imagePath);
      const userId = url.searchParams.get('user_id');
      const imageId = url.searchParams.get('image_id');

      if (userId && imageId) {
        return `${GCS_PUBLIC_URL}/${userId}/${imageId}.png`;
      }
    } catch {
      // Se falhar o parse, retorna a URL original
      return imagePath;
    }
  }

  // Para outras URLs (relativas ou externas), retorna como está
  return imagePath;
}
